import { z } from 'zod';
import type { Papel } from './papeis';

/** Relatórios para baixar em Excel ou PDF (tela Gestão › Relatórios). */
export const RELATORIOS = [
  {
    id: 'vendas',
    titulo: 'Vendas do período',
    descricao: 'Carro, comprador, vendedor, forma de pagamento, valor e lucro de cada venda.',
    papeis: ['dono', 'gerente', 'financeiro'],
    recurso: null,
    periodo: true,
  },
  {
    id: 'comissoes',
    titulo: 'Comissões do mês',
    descricao: 'Quanto cada pessoa da equipe tem a receber, venda por venda.',
    papeis: ['dono', 'gerente', 'financeiro'],
    recurso: null,
    periodo: true,
  },
  {
    id: 'dre',
    titulo: 'DRE (resultado)',
    descricao: 'Receitas, custos, despesas e lucro do período, para o contador.',
    papeis: ['dono', 'financeiro'],
    recurso: 'financeiro_completo',
    periodo: true,
  },
  {
    id: 'contas',
    titulo: 'Contas a pagar e a receber',
    descricao: 'Lançamentos com vencimento no período: valor, situação e data de pagamento.',
    papeis: ['dono', 'financeiro'],
    recurso: null,
    periodo: true,
  },
  {
    id: 'clientes',
    titulo: 'Lista de clientes',
    descricao: 'Contatos, cidade, origem e vendedor (sem CPF, por segurança).',
    papeis: ['dono', 'gerente'],
    recurso: null,
    periodo: false,
  },
  {
    id: 'leads',
    titulo: 'Leads do período',
    descricao: 'Quem chegou, por onde, qual carro queria, quem atendeu e como terminou.',
    papeis: ['dono', 'gerente'],
    recurso: null,
    periodo: true,
  },
] as const satisfies readonly {
  id: string;
  titulo: string;
  descricao: string;
  papeis: readonly Papel[];
  recurso: string | null;
  periodo: boolean;
}[];
export type TipoRelatorio = (typeof RELATORIOS)[number]['id'];

const dia = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Data no formato AAAA-MM-DD');
export const filtroRelatorioSchema = z
  .object({
    formato: z.enum(['xlsx', 'pdf']).default('xlsx'),
    de: dia.optional(),
    ate: dia.optional(),
  })
  .refine((f) => !f.de || !f.ate || f.de <= f.ate, 'O início precisa ser antes do fim')
  .refine(
    (f) =>
      !f.de || !f.ate || new Date(f.ate).getTime() - new Date(f.de).getTime() <= 400 * 86_400_000,
    'Escolha um período de até 13 meses',
  );
export type FiltroRelatorio = z.infer<typeof filtroRelatorioSchema>;
